import { render, staticRenderFns } from "./quit.vue?vue&type=template&id=1af077f2&scoped=true"
import script from "./quit.vue?vue&type=script&lang=js"
export * from "./quit.vue?vue&type=script&lang=js"
import style0 from "./quit.vue?vue&type=style&index=0&id=1af077f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af077f2",
  null
  
)

export default component.exports